import gql from 'graphql-tag';
import FieldsBookingComplete from "graphql/fields/FieldsBookingComplete";

export default gql(`
	query employee( $guid: String!, $booking_date: [String], $active: [String] ) {
		employee( guid: $guid ) {
			guid
			
			bookings( booking_date: $booking_date, active: $active ) {
				${FieldsBookingComplete}
			}
		}
	}
`);

